import { PureComponent } from 'react'

import { theme } from '@procurify/ui-theme'

import { type IBaseButtonProps } from './BaseButton'
import { CircleLoader } from '../Loaders'
import { IconButtonStyled } from './styles/IconButtonStyled'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'

export interface IIconButtonProps extends IBaseButtonProps {
  ['aria-label']: string
  htmlTitle?: string
}

export class IconButton extends PureComponent<IIconButtonProps> {
  public static Styled = IconButtonStyled
  render() {
    const {
      htmlTitle,
      onClick,
      isLoading,
      iconComponent,
      disabled,
      analyticsId,
      ...otherProps
    } = this.props
    const analyticsProps = getAnalyticsDataAttrs(analyticsId)

    return (
      <IconButtonStyled
        title={htmlTitle}
        onClick={!isLoading ? onClick : undefined}
        isLoading={isLoading}
        disabled={disabled || isLoading}
        {...analyticsProps}
        {...otherProps}
      >
        {!this.props.isLoading ? (
          iconComponent
        ) : (
          <CircleLoader
            size={14}
            color={theme.colors.button.icon.content.disabled}
          />
        )}
      </IconButtonStyled>
    )
  }
}
